export const UMB_SLUG = '/webhook';
